import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_590f599c from 'nuxt_plugin_bootstrapvue_590f599c' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_pluginutils_3f5226d0 from 'nuxt_plugin_pluginutils_3f5226d0' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_4762983a from 'nuxt_plugin_pluginrouting_4762983a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_2f1a7a6c from 'nuxt_plugin_pluginmain_2f1a7a6c' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_111b1399 from 'nuxt_plugin_gtm_111b1399' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_workbox_13a0a85f from 'nuxt_plugin_workbox_13a0a85f' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_23372072 from 'nuxt_plugin_metaplugin_23372072' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_axios_d08baffa from 'nuxt_plugin_axios_d08baffa' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_moment_6e3669f5 from 'nuxt_plugin_moment_6e3669f5' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_i18n_926bd3dc from 'nuxt_plugin_i18n_926bd3dc' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_currency_3bb76e12 from 'nuxt_plugin_currency_3bb76e12' // Source: ../plugins/currency.client (mode: 'client')
import nuxt_plugin_mixins_36a27306 from 'nuxt_plugin_mixins_36a27306' // Source: ../plugins/mixins (mode: 'all')
import nuxt_plugin_filters_2abc1387 from 'nuxt_plugin_filters_2abc1387' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_vviewer_5558cd3d from 'nuxt_plugin_vviewer_5558cd3d' // Source: ../plugins/v-viewer (mode: 'all')
import nuxt_plugin_vueuuid_15d0d196 from 'nuxt_plugin_vueuuid_15d0d196' // Source: ../plugins/vue-uuid (mode: 'all')
import nuxt_plugin_bvtoast_5d14ad3c from 'nuxt_plugin_bvtoast_5d14ad3c' // Source: ../plugins/bv-toast (mode: 'all')
import nuxt_plugin_components_567e580a from 'nuxt_plugin_components_567e580a' // Source: ../plugins/components (mode: 'all')
import nuxt_plugin_gtm_550a594d from 'nuxt_plugin_gtm_550a594d' // Source: ../plugins/gtm.client (mode: 'client')
import nuxt_plugin_veevalidate_346f6561 from 'nuxt_plugin_veevalidate_346f6561' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_vuecarousel_828d3144 from 'nuxt_plugin_vuecarousel_828d3144' // Source: ../plugins/vue-carousel.client (mode: 'client')
import nuxt_plugin_vueobservevisibility_31cf76fe from 'nuxt_plugin_vueobservevisibility_31cf76fe' // Source: ../plugins/vue-observe-visibility (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"PosBytz Store","meta":[],"link":[{"rel":"preconnect","href":"https:\u002F\u002Fstorage.googleapis.com"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_590f599c === 'function') {
    await nuxt_plugin_bootstrapvue_590f599c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_3f5226d0 === 'function') {
    await nuxt_plugin_pluginutils_3f5226d0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_4762983a === 'function') {
    await nuxt_plugin_pluginrouting_4762983a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_2f1a7a6c === 'function') {
    await nuxt_plugin_pluginmain_2f1a7a6c(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_111b1399 === 'function') {
    await nuxt_plugin_gtm_111b1399(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_13a0a85f === 'function') {
    await nuxt_plugin_workbox_13a0a85f(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_23372072 === 'function') {
    await nuxt_plugin_metaplugin_23372072(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_d08baffa === 'function') {
    await nuxt_plugin_axios_d08baffa(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_6e3669f5 === 'function') {
    await nuxt_plugin_moment_6e3669f5(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_926bd3dc === 'function') {
    await nuxt_plugin_i18n_926bd3dc(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_currency_3bb76e12 === 'function') {
    await nuxt_plugin_currency_3bb76e12(app.context, inject)
  }

  if (typeof nuxt_plugin_mixins_36a27306 === 'function') {
    await nuxt_plugin_mixins_36a27306(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2abc1387 === 'function') {
    await nuxt_plugin_filters_2abc1387(app.context, inject)
  }

  if (typeof nuxt_plugin_vviewer_5558cd3d === 'function') {
    await nuxt_plugin_vviewer_5558cd3d(app.context, inject)
  }

  if (typeof nuxt_plugin_vueuuid_15d0d196 === 'function') {
    await nuxt_plugin_vueuuid_15d0d196(app.context, inject)
  }

  if (typeof nuxt_plugin_bvtoast_5d14ad3c === 'function') {
    await nuxt_plugin_bvtoast_5d14ad3c(app.context, inject)
  }

  if (typeof nuxt_plugin_components_567e580a === 'function') {
    await nuxt_plugin_components_567e580a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_550a594d === 'function') {
    await nuxt_plugin_gtm_550a594d(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_346f6561 === 'function') {
    await nuxt_plugin_veevalidate_346f6561(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecarousel_828d3144 === 'function') {
    await nuxt_plugin_vuecarousel_828d3144(app.context, inject)
  }

  if (typeof nuxt_plugin_vueobservevisibility_31cf76fe === 'function') {
    await nuxt_plugin_vueobservevisibility_31cf76fe(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
